<template><div class="expert-native native-review">
    <main>
      <header v-show="tab!=='persona'" key="intro" class="native-intro"><h1>{{ tab==='economy'?'경제 환경 분석':'지역 시장 분석' }}</h1><p>{{ tab==='economy'?'통화량·GDP와 아파트 시가총액':'시도·시군구부터 가격·거래·공급까지' }}</p></header>
      <nav key="tabs" class="native-board-tabs" aria-label="분석 화면"><button :aria-pressed="tab==='persona'" @click="selectTab('persona')">목적별 분석 <span>8</span></button><button :aria-pressed="tab==='region'" @click="selectTab('region')">지역 시장 <span>8</span></button><button :aria-pressed="tab==='economy'" @click="selectTab('economy')">경제 환경 <span>2</span></button></nav>
      <div key="native-panels" v-show="tab!=='persona'">
        <original-analysis-board v-if="originalOpened" :mode="analysisTab" :active="active && tab!=='persona'" />
      </div>
      <!-- Fixed sibling hosts prevent Vue's patcher from moving the Tableau iframe ancestor. -->
      <div key="persona-panel" v-show="tab==='persona'">
        <persona-board v-if="personaOpened" :active="active && tab==='persona'" />
      </div>
      <section v-show="tab!=='persona'" key="scope" class="native-review-scope"><p>기존 익스퍼트의 지역 8개·경제 2개 분석을 모았습니다. 전체 분석 목록에서 더 많은 상세 차트를 이용할 수 있습니다.</p></section>
    </main>
</div></template>
<script>
import OriginalAnalysisBoard from './OriginalAnalysisBoard.vue';
import PersonaBoard from '../persona/PersonaBoard.vue';
const validTab=value=>['region','economy','persona'].includes(value)?value:'region';
export default {
  components: { OriginalAnalysisBoard, PersonaBoard },
  props:{active:{type:Boolean,default:true}},
  data() { const tab=validTab(this.$route ? this.$route.query.tab : window.location.hash.slice(1)); return { tab, personaOpened:tab==='persona', originalOpened:tab!=='persona', analysisTab:tab==='economy'?'economy':'region' }; },
  watch: { tab(value) { if(value==='persona')this.personaOpened=true;else{this.originalOpened=true;this.analysisTab=value;} }, '$route.query.tab'(value) { if (this.$route.name === 'insight') this.tab = validTab(value); } },
  methods: {
    selectTab(tab) {
      this.tab = tab;
      if (this.$router) {
        if (this.$route.query.tab !== tab) this.$router.replace({ path: '/insight', query: { ...this.$route.query,tab } });
      } else window.history.replaceState(null, '', `#${tab}`);
    }
  }
};
</script>
<style>
@import './native.css';
@import './region.css';
.native-board-tabs{flex-wrap:wrap}
</style>
